import { ICountryData } from "@interfaces";
import axios from "axios";
import { withAustraliaFirst } from "src/Utilities/countryOrder";

export const externalApi = {
    getDataHomePage: () => {
        const url = "/data/externalData.json";
        return axios.get(url);
    },
    getCountriesDate: async () => {
        const url = "/data/countries.json";
        const response = await axios.get<ICountryData[]>(url);
        return { ...response, data: withAustraliaFirst(response.data) };
    },
};
